import React from 'react'
import {Modal} from "react-bootstrap"
import cennikStyles from "./ModalCennik.module.scss"
import Min60 from "../../images/min60.png"
import Min600 from "../../images/min600.png"
// import Min45 from "../../images/min45.png"
// import JSONData from "../../content/data.json"

function ModalCennik(props) {

    const lte = <>&#x2264;</>
    const lt = <>&#x3C;</>
    const gt = <>&#x3E;</>

    return (
      <Modal
        show={props.show}
        onHide={() => props.handleclose()}
        centered
        size="xl"
      >
        <div className="p-xl-4 p-xxl-5">
          <Modal.Header closeButton>
            <Modal.Title>Cennik</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row mb-3">
              <div className="col-lg-8">
                {/* <h5 className='mb-3 font-bold'>Stacja DC</h5> */}
                <table className={cennikStyles.cennik}>
                  <thead>
                    <tr>
                      <th>Złącze</th>
                      <th>Stawka za ładowanie</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className={cennikStyles.typzlacza}>AC</td>
                      <td className={cennikStyles.cena}>
                        1,95 <span>PLN/kWh</span>
                      </td>
                    </tr>
                    <tr>
                      <td className={cennikStyles.typzlacza}>
                        DC <span>{lte} 50kW</span>
                      </td>
                      <td className={cennikStyles.cena}>
                        2,69 <span>PLN/kWh</span>
                      </td>
                    </tr>
                    <tr>
                      <td className={cennikStyles.typzlacza}>
                        DC <span>50kW {lt} x {lte} 125kW</span>
                      </td>
                      <td className={cennikStyles.cena}>
                        2,89 <span>PLN/kWh</span>
                      </td>
                    </tr>
                    <tr>
                      <td className={cennikStyles.typzlacza}>
                        DC <span>{gt} 125kW</span>
                      </td>
                      <td className={cennikStyles.cena}>
                        3,19 <span>PLN/kWh</span>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div className={`mt-3 p-3 ${cennikStyles.postoj}`}>
                  <strong className="mb-3">
                    Stawka za postój 0,40 PLN/min
                  </strong>
                  <div className="row justify-content-center align-items-start">
                    <div className="col-md-6 mb-3 mb-md-0 ">
                      <div className={cennikStyles.zegar}>
                        <div className="flex-shrink-0">
                          <img src={Min60} alt="" className="img-fluid" />
                        </div>
                        <div className="pl-3 flex-grow-1">
                          DC <span>po 60 min</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className={cennikStyles.zegar}>
                        <div className="flex-shrink-0">
                          <img src={Min600} alt="" className="img-fluid" />
                        </div>
                        <div className="pl-3 flex-grow-1">
                          AC <span>po 720 min</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={`row px-3 pt-3 ${cennikStyles.fontSmall}`}>
                    Stawka za postój naliczana jest po 60 minutach od rozpoczęcia ładowania na złączach DC oraz po 720 min na złączach AC.
                  </div>

                </div>

              </div>
              <div className="col-lg-4">
                <div className={`d-flex flex-column ${cennikStyles.important}`}>
                  <strong>Ważne!</strong>
                  <ul>
                    <li>Zapoznaj się z{'\u00A0'}cennikiem</li>
                    <li>
                      Upewnij się, że korzystasz z{'\u00A0'}najnowszej wersji aplikacji
                      ORLEN Charge
                    </li>
                    <li>
                      Sprawdź dostępność stacji ładowania w{'\u00A0'}aplikacji ORLEN
                      Charge
                    </li>
                    {/* <li>
                      Przed rozpoczęciem sesji ładowania na Twojej karcie
                      płatniczej zostanie zablokowana kwota 200 zł na poczet
                      ładowania DC albo 150 zł za AC
                    </li> */}
                    <li>
                      Po zakończeniu ładowania zwolnij miejsce dla innych
                      kierowców
                    </li>
                  </ul>
                  <p className="mt-auto">
                    Całkowity koszt sesji ładowania jest sumą opłaty za ładowanie
                    PLN/kWh i{'\u00A0'}PLN/min za postój po przekroczeniu czasu
                    granicznego.
                  </p>
                </div>
              </div>
            </div>
          </Modal.Body>
        </div>
      </Modal>
    )
}

export default ModalCennik
